import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Dialog } from '@mui/material';
import { DialogTitle } from '@mui/material';
import { DialogContent } from '@mui/material';
import { DialogActions } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';


const MessageDialog = ({ ouvert, titre, contenu, init, texteNOK, texteOK, onNOK, onOK }) => {

    const [open, setOpen] = useState(ouvert);

    useEffect(() => {
        setOpen(ouvert);
    }, [ouvert, init]);

    const handleNOK = () => {
        setOpen(false);
        if (onNOK) {
            onNOK();
        }
    };

    const handleOK = () => {
        setOpen(false);
        if (onOK) {
            onOK();
        }
    };

    let lignes = contenu ? contenu.split('\n') : [];

    return (
        <Dialog open={open}>
            
            <DialogTitle>
                {titre}
            </DialogTitle>

            <DialogContent dividers>
                {lignes.map((ligne, index) => {
                    return (
                        <Typography key={index}>
                            {ligne}
                        </Typography>
                    );
                })}
            </DialogContent>

            <DialogActions>
                {texteNOK && (
                    <Button
                        variant="standard"
                        color="primary"
                        onClick={handleNOK}>
                        {texteNOK}
                    </Button>
                )}
                <Button
                    variant="contained"
                    color="secondary"
                    autoFocus
                    onClick={handleOK}>
                    {texteOK}
                </Button>
            </DialogActions>

        </Dialog>
    );
}

MessageDialog.propTypes = {
    titre: PropTypes.string.isRequired,
    contenu: PropTypes.string.isRequired,

    texteNOK: PropTypes.string,
    texteOK: PropTypes.string,
    onNOK: PropTypes.func,
    onOK: PropTypes.func,
};

MessageDialog.defaultProps = {
    texteOK: "Ok"
}

export default MessageDialog;